var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.loading)?_c('ZPOverlay',{ref:"overlay",attrs:{"params":_vm.params,"updateData":_vm.updateData},on:{"load":_vm.updateData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }